import { useState } from "react";
import { useMutation } from "@apollo/client";
import {
  Anchor,
  Button,
  PasswordInput,
  Space,
  Text,
  TextInput,
} from "@mantine/core";

import { AUTH_TOKEN } from "../../../constants/authToken";
import { REGISTER_MUTATION } from "../../../queries/auth";
import { useNavigate } from "react-router-dom";

import "./RegisterForm.css";

export default function RegisterForm({ setIsLoginMode }) {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [otpSent, setOtpSent] = useState(false);
	const navigate = useNavigate();
  
	const generateAlias = () => {
		const randomNumber = Math.floor(1000 + Math.random() * 100); 
		return `N${randomNumber}`;
	};
  
	const [startRegister] = useMutation(REGISTER_MUTATION, {
	  onCompleted: ({ createUser }) => {
		console.log(createUser.error);
		if (createUser.response) {
		  localStorage.setItem(AUTH_TOKEN, createUser.response);
		  window.location.href = "/journey";
		} else {
		  alert(createUser.error || "Register failed. Please try again.");
		}
	  },
	});

	const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	const handleRegister = () => {
		if (!name || !email || !password) {
		  alert("Please enter your name, email, and password.");
		  return;
		}
		if (!EMAIL_REGEX.test(email)) {
		  alert("Please enter a valid email address.");
		  return;
		}
		if (password.length < 6) {
		  alert("Password must be at least 6 characters.");
		  return;
		}
	
		// if (otpSent) {
		//   startRegister({
		// 	variables: {
		// 	  name,
		// 	  email,
		// 	  password: hashPassword(password),
		// 	},
		//   });
		// } else {
		//   // Here you can implement the logic to send OTP to the user's phone number
		//   // Once the OTP is sent, you can set the otpSent state to true
		//   setOtpSent(true);
		// }
		startRegister({
			variables: {
				name,
				alias: generateAlias(),
				university: "National University of Singapore",
				email,
				password,
			},
		});
	};
  
	const handleEmailChange = (event) => {
	  setEmail(event.currentTarget.value);
	  setOtpSent(false); // Reset otpSent when email is changed
	};
  
	return (
	  <>
		<TextInput
		  placeholder="John Doe"
		  label="Your Name"
		  size="md"
		  value={name}
		  onChange={(event) => setName(event.currentTarget.value)}
		/>
		<div style={{ display: "flex" }}>
		  <TextInput
			placeholder="example@gmail.com"
			label="Your Email Address"
			size="md"
			value={email}
			onChange={handleEmailChange}
			style={{ width: otpSent ? "48%" : "100%" }}
		  />
		  {/* {otpSent ? (
			<TextInput
			  placeholder="xxxx"
			  label="OTP"
			  size="md"
			  style={{ width: "48%", marginLeft: "16px" }}
			/>
		  ) : (
			<Button
			  variant="default"
			  size="md"
			  style={{ marginLeft: "16px", marginTop: "25px" }}
			  onClick={() => setOtpSent(true)}
			>
			  Get OTP
			</Button>
		  )} */}
		</div>
		<PasswordInput
		  placeholder="Password"
		  label="Password"
		  size="md"
		  value={password}
		  onChange={(event) => setPassword(event.currentTarget.value)}
		/>
		<Space />
		{/* <Button
		  variant="filled"
		  size="md"
		  onClick={handleRegister}
		  disabled={!otpSent || !email} // Disable the button if OTP is not sent or email is empty
		  className="button"
		>
		  {otpSent ? "Register" : "Get OTP"}
		</Button> */}
		<Button
		  variant="filled"
		  size="md"
		  onClick={handleRegister}
		  className="button"
		>
		   Register
		</Button>
		<Space />
		<Text align="center">
		  Already have an account? <br />
		  <Anchor onClick={() => {
			setIsLoginMode(true);
			navigate('/login');
		  }} className="text">Login</Anchor>
		</Text>
	  </>
	);
  }
  